module.exports = __webpack_public_path__ + "static/president-4738ea98a519ab285f8e28e29bbac024.jpg";